import React from "react";
import { Helmet } from "react-helmet";

import PageBackground from "components/Background";
import "pages/styles.scss";


function NotFound(props) {

  return (<React.Fragment>
    <Helmet>
      <meta name="robots" content="noindex,nofollow" />
    </Helmet>
    <div className="HomeMain">
      <div>
        <h1 className="text-white">404 Not Found</h1>
      </div>
      <PageBackground />
    </div>
  </React.Fragment>);
};

export default NotFound;
